/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Divider,
  Anchor,
  BackTop,
} from 'antd';

import GuideTutorialLaunch from '../tutorial/GuideTutorialLaunch';

const { Link } = Anchor;

const guideSectionKey = (section) => [
  section.id,
  section.title,
  section.subtitle,
  section.img,
  section.link,
].filter(Boolean).join('|');

class PageContent extends Component {
  showExtensions = () => {
    return (
      <ul className="guide-page-content__support-list">
        <li>Athenahealth</li>
        <li>eClinicalWorks (Web App)</li>
        <li>Kareo</li>
        <li>Nymbl Systems</li>
        <li>EMA / Modernizing Medicine</li>
        <li>DrChrono</li>
        <li>Practice Fusion</li>
        <li>AdvancedMD</li>
        <li>Simple Practice</li>
      </ul>
    );
  };

  showUploadRecordMenu = () => {
    const { selectingGuideMenuItem } = this.props;
    return (
      <ol className="guide-page-content__support-list">
        <li>
          <div role="link" onClick={() => selectingGuideMenuItem({ key: 10 })} style={{ cursor: 'pointer' }}>
            Medsender Printer Driver
          </div>
        </li>
        <li>
          <div role="link" onClick={() => selectingGuideMenuItem({ key: 9 })} style={{ cursor: 'pointer' }}>
            Medsender EMR integration
          </div>
        </li>
        <li>Manual upload to Medsender</li>
      </ol>
    );
  };

  render() {
    const { copy, selectingGuideMenuItem } = this.props;
    const {
      sections,
      pageTitle,
      pageSubtitle,
      page,
    } = copy;
    return (
      <div className="guide-page-content">
        <article className="guide-page-content__article">
          <BackTop style={{ zIndex: 1000 }} />
          <h1>{pageTitle}</h1>
          <p className="guide-page-content__subtitle">{pageSubtitle}</p>
          {page === 'chrome_extensions' && this.showExtensions()}
          {page === 'upload_record' && this.showUploadRecordMenu()}
          {sections.map((section, index) => (
            <React.Fragment key={guideSectionKey(section)}>
              <h2 data-scrollama-index={index} id={section.id}>{section.title}</h2>
              {section.link
                ? (
                  <a className="guide-page-content__section-link" target="_blank" rel="noopener noreferrer" href={section.link}>{section.subtitle}</a>
                ) : (
                  <p className="guide-page-content__section-copy">{section.subtitle}</p>
                )}
              {section.img && <img alt="" className="guide-page-content__image" src={section.img} />}
              <div className="guide-page-content__cards">
                {section.cards && section.cards.map((card) => (
                  <Card className="guide-page-content__card" key={card.title} title={card.title} onClick={() => selectingGuideMenuItem({ key: card.menuItemIndex })}>
                    {card.sections.map((label) => (
                      <p key={label}>{label}</p>
                    ))}
                  </Card>
                ))}
              </div>
              {section.divider && <Divider />}
            </React.Fragment>
          ))}
        </article>
        {/* The rail wrapper exists so the tutorial launcher can sit under the
            section links and still be visible on narrow screens, where the
            Anchor itself is hidden (see guide.scss). */}
        <div className="guide-page-content__rail">
          <Anchor className="guide-page-content__anchor">
            {sections.map((section) => (
              section.title && <Link key={guideSectionKey(section)} href={`#${section.id}`} title={section.title} />
            ))}
          </Anchor>
          <GuideTutorialLaunch />
        </div>
      </div>
    );
  }
}

PageContent.propTypes = {
  copy: PropTypes.object.isRequired,
  selectingGuideMenuItem: PropTypes.func.isRequired,
};

export default PageContent;
